import * as React from 'react';

import {Radio} from 'shells/radio/radio';
import {RadioGroup} from 'shells/radio/radio-group';
import {SavedSettingToast} from 'shells/saved-setting-toast/saved-setting-toast';

import type {CalendarFragment as Calendar} from 'nutshell-graphql-types';

import {useUpdateCalendarExportRule} from './graphql/hooks/use-update-calendar-export-rule';
import {getComponentKey} from './helpers';

type Props = {
    calendar: Calendar | null | undefined;
    serviceName: string;
    disabled: boolean;
};

export function CalendarExportRuleRadioGroup(props: Props) {
    const [valueSaved, setValueSaved] = React.useState<string | null | undefined>(null);
    const savedTimeoutRef = React.useRef();

    const componentKey = React.useRef<string>(getComponentKey());

    const {updateCalendarExportRule, isLoading} = useUpdateCalendarExportRule();
    const isDisabled = props.disabled || !props.calendar || isLoading;

    const exportRule = (props.calendar && props.calendar.exportRule) || 'ALL';

    return (
        <RadioGroup
            name={`activity-sync-${componentKey.current}`}
            size='big'
            selectedValue={exportRule}
            onChange={(value) => {
                if (props.calendar) {
                    updateCalendarExportRule({
                        calendarId: props.calendar.id,
                        // @ts-expect-error
                        exportRule: value,
                    }).then((mutationResult) => {
                        setValueSaved(
                            mutationResult &&
                                mutationResult.data &&
                                mutationResult.data.calendarExportRuleUpdate &&
                                mutationResult.data.calendarExportRuleUpdate.calendar.exportRule
                        );
                        if (savedTimeoutRef.current) {
                            clearTimeout(savedTimeoutRef.current);
                        }
                        // @ts-expect-error
                        savedTimeoutRef.current = setTimeout(() => {
                            setValueSaved(null);
                        }, 1000);
                    });
                }
            }}
        >
            <SavedSettingToast state={valueSaved === 'ALL' ? 'complete' : 'initial'}>
                <Radio value='ALL' disabled={isDisabled}>
                    All activities created in Nutshell
                </Radio>
            </SavedSettingToast>
            {NutClientConfig.hasNewActivityModalEverywhereFF ? (
                <SavedSettingToast state={valueSaved === 'NONE' ? 'complete' : 'initial'}>
                    <Radio value='NONE' disabled={isDisabled}>
                        Only activities I choose
                    </Radio>
                </SavedSettingToast>
            ) : (
                <>
                    <SavedSettingToast state={valueSaved === 'IMPORTANT' ? 'complete' : 'initial'}>
                        <Radio value='IMPORTANT' disabled={isDisabled}>
                            Only activities created in Nutshell marked “important”
                        </Radio>
                    </SavedSettingToast>
                    <SavedSettingToast state={valueSaved === 'NONE' ? 'complete' : 'initial'}>
                        <Radio value='NONE' disabled={isDisabled}>
                            None: Do not add activities created in Nutshell to {props.serviceName}
                        </Radio>
                    </SavedSettingToast>
                </>
            )}
        </RadioGroup>
    );
}
